import { type NavigationGuard } from 'vue-router';
import { RouteName } from './types';
import { useScreenOrientation } from '@/hooks/use-screen-orientation';

const isActiveWorkoutPlayer = (path: string) => {
  // Only the live player route should unlock orientation.
  // Finish/feedback still contain `/player/` but must stay portrait so leaving
  // them for the story upload screen does not force a late orientation lock
  // (which can recreate the activity / flash the native splash on device).
  const playerSegment = `/${RouteName.WorkoutPlayer}/`;
  const playerIndex = path.indexOf(playerSegment);
  if (playerIndex === -1) return false;
  const afterPlayer = path.slice(playerIndex + playerSegment.length);
  return !!afterPlayer && !afterPlayer.includes('/');
};

export const orientationGuard: NavigationGuard = async (to, from, next) => {
  const { lockToPortrait, unlock } = useScreenOrientation();

  if (isActiveWorkoutPlayer(to.path)) {
    unlock();
  } else {
    lockToPortrait();
  }

  next();
};
